/// Menu
//import Metismenu from "metismenujs";
import React, { useReducer, useContext, useEffect, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import { Collapse, Dropdown } from "react-bootstrap";
/// Link
import { Link } from "react-router-dom";
import { MenuList } from "./Menu";

import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import LogoutPage from "./Logout";
/// Image
import profile from "../../../images/profile/users.png"; //! change this to be the guest image
import { useSelector } from "react-redux";
import { applyRolesOnMenu } from "../../components/Jobs/utils";
import { useAuth0 } from "@auth0/auth0-react";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // const {user}= JSON.parse(localStorage.getItem('userDetails'));
  const { auth } = useSelector((state) => state.auth);
  const { user } = useAuth0();
  // apply Roles
  let updatedMenuList = applyRolesOnMenu(MenuList, auth.user.role);
  let d = new Date();
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  // Remove the conflicting useEffect that was adding another event listener
  useEffect(() => {
    // Clean up function to remove any existing event listeners
    return () => {
      const btn = document.querySelector(".nav-control");
      if (btn) {
        // Remove any existing listeners (though we're not adding them here anymore)
        btn.removeEventListener("click", () => {});
      }
    };
  }, []);

  let handleheartBlast = document.querySelector(".heart");
  function heartBlast() {
    return handleheartBlast.classList.toggle("heart-blast");
  }

  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const displayUsername = (username) => {
    if (username && username.length > 8) {
      return username.slice(0, 8) + "...";
    }
    return username;
  };

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <Dropdown
          as="div"
          className="header-profile2 dropdown"
          show={dropdownOpen}
          onToggle={setDropdownOpen}
        >
          <Dropdown.Toggle
            as="div"
            variant=""
            className="i-false c-pointer"
            role="button"
            data-toggle="dropdown"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <div className="header-info2 d-flex align-items-center">
              <img src={auth.user.avatar || profile} width={20} alt="" />
              <div className="d-flex align-items-center sidebar-info">
                <div>
                  <span
                    className="font-w400 d-block"
                    style={{ textTransform: "capitalize" }}
                  >
                    {displayUsername(user.username) ||
                      displayUsername(user.nickname) ||
                      auth.user.given_name ||
                      ""}
                  </span>
                  <small
                    className="text-end font-w400"
                    style={{ textTransform: "capitalize" }}
                  >
                    {auth.user.role || ""}
                  </small>
                </div>
                <i className="fas fa-chevron-down"></i>
              </div>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu
            align="end"
            className="dropdown-menu dropdown-menu-end"
          >
            <Link
              to="/app-profile"
              className="dropdown-item ai-icon"
              onClick={() => setDropdownOpen(false)} // Add this line
            >
              <svg
                id="icon-user1"
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary"
                width={18}
                height={18}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx={12} cy={7} r={4} />
              </svg>
              <span className="ms-2">Profile</span>
            </Link>
            <LogoutPage />
          </Dropdown.Menu>
        </Dropdown>
        <ul className="metismenu" id="menu">
          {updatedMenuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={` ${
                    state.active === data.title ? "mm-active" : ""
                  }`}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow"
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                        <span className="badge badge-xs style-1 badge-danger">
                          {data.update}
                        </span>
                      </Link>
                      <Collapse in={state.active === data.title ? true : false}>
                        <ul
                          className={`${
                            menuClass === "mm-collapse" ? "mm-show" : ""
                          }`}
                        >
                          {data.content &&
                            data.content.map((data, subIndex) => {
                              return (
                                <li
                                  key={subIndex}
                                  className={`${
                                    state.activeSubmenu === data.title
                                      ? "mm-active"
                                      : ""
                                  }`}
                                >
                                  {data.content && data.content.length > 0 ? (
                                    <>
                                      <Link
                                        to={data.to}
                                        className={
                                          data.hasMenu ? "has-arrow" : ""
                                        }
                                        onClick={() => {
                                          handleSubmenuActive(data.title);
                                        }}
                                      >
                                        {data.title}
                                      </Link>
                                      <Collapse
                                        in={
                                          state.activeSubmenu === data.title
                                            ? true
                                            : false
                                        }
                                      >
                                        <ul
                                          className={`${
                                            menuClass === "mm-collapse"
                                              ? "mm-show"
                                              : ""
                                          }`}
                                        >
                                          {data.content &&
                                            data.content.map(
                                              (data, subSubIndex) => {
                                                return (
                                                  <>
                                                    <li key={subSubIndex}>
                                                      <Link
                                                        className={`${
                                                          path === data.to
                                                            ? "mm-active"
                                                            : ""
                                                        }`}
                                                        to={data.to}
                                                      >
                                                        {data.title}
                                                      </Link>
                                                    </li>
                                                  </>
                                                );
                                              }
                                            )}
                                        </ul>
                                      </Collapse>
                                    </>
                                  ) : (
                                    <Link to={data.to}>{data.title}</Link>
                                  )}
                                </li>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link to={data.to}>
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
